import { ConfirmationCodeResult } from './common'

import { nonNullable } from 'lib/array/arrayUtils'
import { getPlural } from 'lib/string/pluralize'
import { useOrder } from 'tripPlanner/hooks/api'
import { AirbnbItem, HotelItem } from 'tripPlanner/types/tripItem'
import { getOrderId } from 'tripPlanner/utils'

export default function useAccommodationItemConfirmationCodes(
  item: HotelItem | AirbnbItem,
): ConfirmationCodeResult {
  const orderId = getOrderId(item)

  const { data: order, isLoading: isOrderLoading } = useOrder(orderId)

  if (orderId && item.type === 'HOTEL') {
    // This is an LE hotel booking
    if (order) {
      const bookingIds = order.items
        .filter(
          (orderItem) =>
            orderItem.bookingNumber && orderItem.offerId === item.code,
        )
        .map((orderItem) => orderItem.bookingNumber)

      return {
        hasCode: bookingIds.length > 0,
        codes: bookingIds,
        codeString: bookingIds.join(', '),
        label: getPlural('Booking ID', bookingIds.length),
        isLoading: isOrderLoading,
      }
    } else {
      return {
        hasCode: false,
        codes: [],
        codeString: '',
        label: 'Booking ID',
        isLoading: isOrderLoading,
      }
    }
  } else {
    // This is a custom item or a bookmark
    const confirmationCode = item.confirmationCode
    return {
      hasCode: !!confirmationCode,
      codes: nonNullable([confirmationCode]),
      codeString: confirmationCode,
      label: 'Confirmation number',
      isLoading: false,
    }
  }
}
